
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91competitionname_93SjPOv_453MgbxaWnlp5_LtG4g4KgePFu9omxu_45Hi9t0uwMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/competition/[competitionname].vue?macro=true";
import { default as _91id_93kwkBOe4I5PbxflbT0gQSVRhJnLDM0Qy9RAN6NFAwmgkMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/booking-confirmation/[id].vue?macro=true";
import { default as _91tripname_93dgNdxm9mVgyAeM18_45YrBrwH_ZoG58R2cVnoM9BQ22qEMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/titinerary/[tripname].vue?macro=true";
import { default as _91ocr_93IohhnPbZUjwXDX4pxokEHKjSLeFVlKRmtpmdjDEgLSAMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/booking-finish/[ocr].vue?macro=true";
import { default as _91ocr_93gEUYtifZZlYzdJd3nSxT_45HNqdPibTAO6QpRlVsPPZ_cMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/bookingfaq/[ocr].vue?macro=true";
import { default as _91name_93KePT7wZoM65BIAq3W2yazW1xawEZWSn6LhZ3Me9f_YMMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/shipinfo/[name].vue?macro=true";
import { default as _91name_93o_45UUQKpg1tfb4dDfqV6t78LyVTlqXSEKy44Rv_45J4eOgMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/solresor-web/pages/campaign/[name].vue?macro=true";
import { default as _91id_93MpEgabFYVTnCYrL8Yh7hxvObWBBC_pKeugN3aSgiBf8Meta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/payment/[id].vue?macro=true";
import { default as _91jwt_93K91AJAXr60NxCf9zu_45nthKSqxiQfLAu9ClcM2PLLzjoMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/app/l/[jwt].vue?macro=true";
import { default as _91id_93O2k3Cy6BpKgteCGsdzDVVw2v4uiAhULVzUhHClFtYO0Meta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/fn/[id].vue?macro=true";
import { default as faqxGDJ8M_45jEXcWJ5u6mg7lDJgkKWiAO_91Wq_UkS4NjSYMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/faq.vue?macro=true";
import { default as indexoIlSyOiqxhXJBJu75va4WsOokJfgklJvQ86APRuqN90Meta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/solresor-web/pages/index.vue?macro=true";
import { default as searchoqrv7E8rcg39ifoejGPbMRIp8s_45vVdHQ0ojIVCzgTmwMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/search.vue?macro=true";
import { default as byebyeiebrPu38a3AetKr6fR8DAyGs9x1123nSnQd0h8nftHQv8Meta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/byebyeie.vue?macro=true";
import { default as indexDFvQwh_45nHrKPmiVIl9HWDonmegJuUdy2RlnAOec8q7wMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/app/index.vue?macro=true";
import { default as complaintV_45H_SQcuvOQhmHXDLOzg4ch9qyp2YfV8ofYbpPjcDQQMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/complaint.vue?macro=true";
import { default as indexFVJ9zwKJS4X90lWoNhyRvHI62nHETegLEt5pSUw2zkwMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/info/index.vue?macro=true";
import { default as newsletteraPcvEnlexbrOjvUy_45OC67xJDpetgc4lmcitM0d5x3zkMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/newsletter.vue?macro=true";
import { default as index79z5hLkEJ1JqHBZNFa1TYg8kGdVvdWPWh5COk3fwiNkMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/hotels/index.vue?macro=true";
import { default as indexPfNSh2f5503QmsxrYB46utl4VSRbk4KlzWnFqaqwliEMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/review/index.vue?macro=true";
import { default as chartersearchXYzPVb7LywsNk2vN3976YStI6PPGXz7t0jKOroSqmdYMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/solresor-web/pages/chartersearch.vue?macro=true";
import { default as _91id_93admwHCVUhmxHtc3rmF9NmNEJEMlu8cbceWGeBF13NBwMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/giftcard/[id].vue?macro=true";
import { default as _91name_93pR9yVmzES4h1xW1rdUa_45Czr9QVwPoLR2Nawe6TCj_E4Meta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/hotels/[name].vue?macro=true";
import { default as indexwE1ts1qNYqL21OpcYrTmlLEWiKJMYz2mWhHn5DZFMC4Meta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/giftcard/index.vue?macro=true";
import { default as _91_91tab_93_93GHMtqh_45NbHGDCjCtYenK_OG9T8qATGBiA1bEU_45uRtEkMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/mytrip/[[tab]].vue?macro=true";
import { default as searchsDv03aO7UOw7NMfA3_jyht8MX6pbrpkv_F_453FckeawIMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/package/search.vue?macro=true";
import { default as failed_45bj7v_45gulNZZ1Q_45mXixAX1_45xJqy_453fYICP_xrKq2miwMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/payment/failed.vue?macro=true";
import { default as _91pagename_93StMX69uingYVhyWcJIlxj8Ah0VPDgDk_LPOHfvyK8CYMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/info/[pagename].vue?macro=true";
import { default as indexqJ2cfUHJIJ48HzvMyPbJPk_eNg31f1G13gY4S989O1MMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/solresor-web/pages/favourites/index.vue?macro=true";
import { default as indexlaDorkujyms_EEodbiMd9IUoMzcqVT1D0QmAT3leJEYMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/tourleader/index.vue?macro=true";
import { default as index5JQVWRXpwg4VXzIb_eJQ51yTflqr__nQADi06GbjmmgMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/solresor-web/pages/destination/index.vue?macro=true";
import { default as verification_45done7kAojesdz_45EwJTf2T9dJ7yHJMcsZ57fDsF_45wXn_4566C4Meta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/verification-done.vue?macro=true";
import { default as _91_91tab_93_93Vth_2QIbTwXPs7Ms7VRQivUKSeueJ0rBzTglJDtnVUwMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/hotel/[id]/[[tab]].vue?macro=true";
import { default as gruppresorbxqOPmFeVEPYk_qA_7dcQXMRt8S_45FMLi_ayhHJVXhqYMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/solresor-web/pages/campaign/gruppresor.vue?macro=true";
import { default as _91_91tab_93_93QYuTTodbJ7opef96UFTGXmAN4oBJ6IYX0SI7mgmo3iAMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/package/[id]/[[tab]].vue?macro=true";
import { default as _91_91step_93_93BtsIYFIQX_a4DRLtbQZj7WHhJ_45_45Mmf2V85FW2CkV1pMMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/book/[tripid]/[[step]].vue?macro=true";
import { default as _91_91tab_93_93KSBpA_45WjS3cisOcwLCLBYOaGlWCFRtM_45DyIOkBp_45l3oMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/tourleader/[id]/[[tab]].vue?macro=true";
import { default as _91_91tab_93_93HZTNc7GgIhGYMgUWikL39R3vKHtWKY8miWg075nOOIgMeta } from "/home/ubuntu/frontend-deploy/repo/continous/src/applications/solresor-web/pages/destination/[id]/[[tab]].vue?macro=true";
import { default as _91_91tab_93_93J_45gWpXj6IOgcdgVuU50e_45ktw_45mo3hFUbAB8RA6Yqex4Meta } from "/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/[triptype]/[tripname]/[[tab]].vue?macro=true";
import { default as component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta } from "/home/ubuntu/frontend-deploy/repo/continous/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A } from "/home/ubuntu/frontend-deploy/repo/continous/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "competition",
    path: "/tavling",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/competition/[competitionname].vue")
  },
  {
    name: "booking-confirmation",
    path: "/booking-confirmation",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/booking-confirmation/[id].vue")
  },
  {
    name: "titinerary",
    path: "/dagprogram",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/titinerary/[tripname].vue")
  },
  {
    name: "booking-finish",
    path: "/booking-finish",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/booking-finish/[ocr].vue")
  },
  {
    name: "bookingfaq",
    path: "/boknings-faq",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/bookingfaq/[ocr].vue")
  },
  {
    name: "shipinfo",
    path: "/fartyg",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/shipinfo/[name].vue")
  },
  {
    name: "campaign",
    path: "/campaign",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/solresor-web/pages/campaign/[name].vue")
  },
  {
    name: "payment",
    path: "/payment",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/payment/[id].vue")
  },
  {
    name: "app-l",
    path: "/app/l",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/app/l/[jwt].vue")
  },
  {
    name: "fn",
    path: "/fn",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/fn/[id].vue")
  },
  {
    name: "faq",
    path: "/faq",
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/faq.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/solresor-web/pages/index.vue")
  },
  {
    name: "search",
    path: "/sok",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/search.vue")
  },
  {
    name: "fn-id",
    path: "/fn/:id()",
    meta: _91id_93O2k3Cy6BpKgteCGsdzDVVw2v4uiAhULVzUhHClFtYO0Meta || {},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/fn/[id].vue")
  },
  {
    name: "byebyeie",
    path: "/byebyeie",
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/byebyeie.vue")
  },
  {
    name: "app",
    path: "/app",
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/app/index.vue")
  },
  {
    name: "complaint",
    path: "/reklamation",
    meta: { ...(complaintV_45H_SQcuvOQhmHXDLOzg4ch9qyp2YfV8ofYbpPjcDQQMeta || {}), ...{"custom":true} },
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/complaint.vue")
  },
  {
    name: "info",
    path: "/info",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/info/index.vue")
  },
  {
    name: "newsletter",
    path: "/nyhetsbrev",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/newsletter.vue")
  },
  {
    name: "app-l-jwt",
    path: "/app/l/:jwt()",
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/app/l/[jwt].vue")
  },
  {
    name: "hotels",
    path: "/hotell",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/hotels/index.vue")
  },
  {
    name: "payment-id",
    path: "/payment/:id()",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/payment/[id].vue")
  },
  {
    name: "review",
    path: "/utvardera-resa",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/review/index.vue")
  },
  {
    name: "chartersearch",
    path: "/sok-charter",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/solresor-web/pages/chartersearch.vue")
  },
  {
    name: "giftcard-id",
    path: "/presentkort/:id()",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/giftcard/[id].vue")
  },
  {
    name: "hotels-name",
    path: "/hotell/:name()",
    meta: { ...(_91name_93pR9yVmzES4h1xW1rdUa_45Czr9QVwPoLR2Nawe6TCj_E4Meta || {}), ...{"custom":true} },
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/hotels/[name].vue")
  },
  {
    name: "giftcard",
    path: "/presentkort",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/giftcard/index.vue")
  },
  {
    name: "mytrip-tab",
    path: "/dinresa/:tab?",
    meta: { ...(_91_91tab_93_93GHMtqh_45NbHGDCjCtYenK_OG9T8qATGBiA1bEU_45uRtEkMeta || {}), ...{"custom":true} },
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/mytrip/[[tab]].vue")
  },
  {
    name: "package-search",
    path: "/sok-packages",
    meta: { ...(searchsDv03aO7UOw7NMfA3_jyht8MX6pbrpkv_F_453FckeawIMeta || {}), ...{"custom":true} },
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/package/search.vue")
  },
  {
    name: "payment-failed",
    path: "/payment/failed",
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/payment/failed.vue")
  },
  {
    name: "campaign-name",
    path: "/campaign/:name()",
    meta: { ...(_91name_93o_45UUQKpg1tfb4dDfqV6t78LyVTlqXSEKy44Rv_45J4eOgMeta || {}), ...{"custom":true} },
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/solresor-web/pages/campaign/[name].vue")
  },
  {
    name: "info-pagename",
    path: "/info/:pagename()",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/info/[pagename].vue")
  },
  {
    name: "shipinfo-name",
    path: "/fartyg/:name()",
    meta: { ...(_91name_93KePT7wZoM65BIAq3W2yazW1xawEZWSn6LhZ3Me9f_YMMeta || {}), ...{"custom":true} },
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/shipinfo/[name].vue")
  },
  {
    name: "bookingfaq-ocr",
    path: "/boknings-faq/:ocr()",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/bookingfaq/[ocr].vue")
  },
  {
    name: "favourites",
    path: "/favourites",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/solresor-web/pages/favourites/index.vue")
  },
  {
    name: "tourleader",
    path: "/reseledare",
    meta: { ...(indexlaDorkujyms_EEodbiMd9IUoMzcqVT1D0QmAT3leJEYMeta || {}), ...{"custom":true} },
    alias: ["/reseledare/lista"],
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/tourleader/index.vue")
  },
  {
    name: "destination",
    path: "/destination",
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/solresor-web/pages/destination/index.vue")
  },
  {
    name: "verification-done",
    path: "/verification-done",
    meta: verification_45done7kAojesdz_45EwJTf2T9dJ7yHJMcsZ57fDsF_45wXn_4566C4Meta || {},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/verification-done.vue")
  },
  {
    name: "hotel-id-tab",
    path: "/hotell/:id()/:tab?",
    meta: { ...(_91_91tab_93_93Vth_2QIbTwXPs7Ms7VRQivUKSeueJ0rBzTglJDtnVUwMeta || {}), ...{"custom":true} },
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/hotel/[id]/[[tab]].vue")
  },
  {
    name: "campaign-gruppresor",
    path: "/campaign/gruppresor",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/solresor-web/pages/campaign/gruppresor.vue")
  },
  {
    name: "booking-finish-ocr",
    path: "/booking-finish/:ocr()",
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/booking-finish/[ocr].vue")
  },
  {
    name: "package-id-tab",
    path: "/paket/:id()/:tab?",
    meta: { ...(_91_91tab_93_93QYuTTodbJ7opef96UFTGXmAN4oBJ6IYX0SI7mgmo3iAMeta || {}), ...{"custom":true} },
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/package/[id]/[[tab]].vue")
  },
  {
    name: "titinerary-tripname",
    path: "/dagprogram/:tripname()",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/titinerary/[tripname].vue")
  },
  {
    name: "book-tripid-step",
    path: "/boka/:tripid()/:step?",
    meta: { ...(_91_91step_93_93BtsIYFIQX_a4DRLtbQZj7WHhJ_45_45Mmf2V85FW2CkV1pMMeta || {}), ...{"custom":true} },
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/book/[tripid]/[[step]].vue")
  },
  {
    name: "tourleader-id-tab",
    path: "/reseledare/:id()/:tab?",
    meta: { ...(_91_91tab_93_93KSBpA_45WjS3cisOcwLCLBYOaGlWCFRtM_45DyIOkBp_45l3oMeta || {}), ...{"custom":true} },
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/tourleader/[id]/[[tab]].vue")
  },
  {
    name: "destination-id-tab",
    path: "/destination/:id()/:tab?",
    meta: _91_91tab_93_93HZTNc7GgIhGYMgUWikL39R3vKHtWKY8miWg075nOOIgMeta || {},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/applications/solresor-web/pages/destination/[id]/[[tab]].vue")
  },
  {
    name: "booking-confirmation-id",
    path: "/booking-confirmation/:id()",
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/booking-confirmation/[id].vue")
  },
  {
    name: "triptype-tripname-tab",
    path: "/:triptype([a-zåäöøæ0-9A-F%][a-zåäöøæ0-9A-F%\\- _]{2,})/:tripname([a-zåäöøæü0-9A-F%][a-zåäöøæü0-9A-F%\\- _]{2,})/:tab([a-zåäöøæü0-9A-F%\\- _]+)?",
    meta: _91_91tab_93_93J_45gWpXj6IOgcdgVuU50e_45ktw_45mo3hFUbAB8RA6Yqex4Meta || {},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/[triptype]/[tripname]/[[tab]].vue")
  },
  {
    name: "competition-competitionname",
    path: "/tavling/:competitionname()",
    meta: {"custom":true},
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/competition/[competitionname].vue")
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-installd",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/alla-resor",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/julmarkandsresor",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/sportlov",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/sportlov/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/sportlov/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/pasklov",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/pasklov/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/pasklov/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/sommarlov",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/sommarlov/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/sommarlov/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/hostlov",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/hostlov/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/hostlov/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/charterresor",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/charterresor/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/charterresor/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/all-inclusive",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/all-inclusive/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/all-inclusive/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/kontakt",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/kontakt/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/kontakt/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/om-oss",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/om-oss/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/om-oss/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/om-oss/arbeta-for-oss",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/om-oss/arbeta-for-oss/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/om-oss/arbeta-for-oss/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/egypten/all-inclusive",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/egypten/all-inclusive/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/egypten/all-inclusive/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/indonesien",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/indonesien/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/indonesien/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/spanien/la-palma",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/spanien/la-palma/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/spanien/la-palma/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/spanien/mallorca",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/spanien/mallorca/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/spanien/mallorca/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/spanien/teneriffa",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/spanien/teneriffa/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/spanien/teneriffa/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/spanien/gran-canaria",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/spanien/gran-canaria/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/spanien/gran-canaria/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/spanien/costa-de-almeria",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/spanien/costa-de-almeria/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/spanien/costa-de-almeria/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/portugal/azorerna",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/portugal/azorerna/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/portugal/azorerna/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/portugal/lissabon",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/portugal/lissabon/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/portugal/lissabon/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/portugal/porto",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/portugal/porto/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/portugal/porto/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/italien/rom",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/italien/rom/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/italien/rom/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/grekland/zakynthos",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/grekland/zakynthos/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/grekland/zakynthos/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/grekland/santorini",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/grekland/santorini/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/grekland/santorini/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/rundresor/centralamerika/kuba",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/rundresor/centralamerika/kuba/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/rundresor/centralamerika/kuba/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/sommarresor",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/sommarresor/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/sommarresor/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/flygstol",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/flygstol/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/flygstol/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/golfresor",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/golfresor/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/golfresor/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/aktiv",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/aktiv/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/aktiv/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/italien",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/italien/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/resa-till/italien/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/Templates",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/Templates/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/Templates/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/hotel",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/hotel/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/hotel/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/dinbokning",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/dinbokning/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/dinbokning/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/dinbokning-aktuell",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/dinbokning-aktuell/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/dinbokning-aktuell/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/campaign/blackfriday",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/campaign/blackfriday/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/campaign/blackfriday/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/erbjudanden",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/erbjudanden/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/erbjudanden/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/sista-minuten",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/sista-minuten/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/sista-minuten/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/sista-minuten-erbjudanden",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/sista-minuten-erbjudanden/",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0AMeta?.name,
    path: "/sista-minuten-erbjudanden/:pathMatch(.*)",
    component: component_45stubNr439Yo_ZDOgwsr4JSUnmKItwhPCycLwg5WYdUp7_0A
  },
  {
    name: "localized-tourleader",
    path: "/:locale(zz)/reseledare/lista",
    meta: { ...(indexlaDorkujyms_EEodbiMd9IUoMzcqVT1D0QmAT3leJEYMeta || {}), ...{"custom":true} },
    component: () => import("/home/ubuntu/frontend-deploy/repo/continous/src/layers/web/pages/tourleader/index.vue")
  }
]